interface CategorySkeletonProps {}

const ShimmerCard = () => (
  <div className="flex w-full max-w-[20rem] flex-col gap-[1.2rem] sm:max-w-[29.5rem]">
    <div className="aspect-square w-full animate-pulse rounded-[1.6rem] bg-brand-light-gray"></div>
    <div className="flex h-[7.7rem] flex-col gap-[.4rem]">
      <div className="h-[3rem] w-11/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
      <div className="h-[3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
    </div>
  </div>
);

const CategorySkeleton = ({}: CategorySkeletonProps) => {
  return (
    <div className="mt-16 min-h-screen w-full">
      {/* page header */}
      <div className="mt-[6rem] sm:mx-auto sm:max-w-content">
        <div className="flex w-full items-start gap-x-8">
          {/* left nav */}
          <div className="hidden h-[103.5rem] w-full min-w-[28.2rem] max-w-[28.2rem] flex-col gap-[4.3rem] lg:flex">
            <div>
              <div className="mb-[1.9rem] h-[2.2rem] w-full animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
              <div className="flex flex-col gap-[1.2rem]">
                <div className="h-[2rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
              </div>
            </div>
            <div>
              <div className="mb-[1.9rem] h-[2.2rem] w-full animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
              <div className="flex justify-between gap-[1.2rem]">
                <div className="h-[4.4rem] w-[13rem] animate-pulse rounded-full bg-brand-light-gray" />
                <div className="h-[4.4rem] w-[13rem] animate-pulse rounded-full bg-brand-light-gray" />
              </div>
            </div>
            <div>
              <div className="mb-[1.9rem] h-[2.2rem] w-full animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
              <div className="flex flex-col gap-[1.2rem]">
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
              </div>
            </div>
            <div>
              <div className="mb-[1.9rem] h-[2.2rem] w-full animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
              <div className="flex flex-col gap-[1.2rem]">
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
                <div className="h-[2.3rem] w-8/12 animate-pulse rounded-[1.6rem] bg-brand-light-gray" />
              </div>
            </div>
          </div>
          {/* top bar and results */}
          <div className="flex w-full flex-col gap-[1.2rem]">
            <div className="flex h-[4.4rem] w-full justify-between px-4 sm:px-0">
              <div className="h-full w-1/6 animate-pulse rounded-full bg-brand-light-gray" />
              <div className="h-full w-1/3 animate-pulse rounded-full bg-brand-light-gray" />
            </div>
            <div className="mt-[4rem] grid grid-cols-2 gap-x-[1.6rem] gap-y-[2rem] px-4 sm:mx-auto sm:max-w-default sm:justify-start sm:gap-x-[1.6rem] sm:gap-y-[0.25rem] sm:px-0 lg:grid-cols-[repeat(4,29.5rem)] lg:gap-x-[2rem] lg:gap-y-[5rem]">
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
              <ShimmerCard />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategorySkeleton;
